/* BlueTruck24 hub theme — catalog / search filters (snippets/bt-facets.liquid).
   One GET form (#bt-facets-form) owns the filter checkboxes, the price inputs and the sort
   <select> through the `form` attribute; Shopify's native storefront filtering does the rest.
   This file only: auto-submits on change, keeps the URL clean, drives the mobile "Filters" toggle. */
(function () {
  'use strict';

  var form = document.querySelector('[data-bt-facets-form]');
  var toggle = document.querySelector('[data-bt-facets-toggle]');
  var sidebar = document.querySelector('[data-bt-facets-sidebar]');
  var OPEN_KEY = 'bt-facets-open';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  // ── Mobile toggle (Hydrogen: filtersOpen ? 'block' : 'hidden', caret rotate-180) ──
  function isOpen() {
    return !!sidebar && sidebar.classList.contains('block');
  }

  function setOpen(open) {
    if (!sidebar) return;
    sidebar.classList.toggle('hidden', !open);
    sidebar.classList.toggle('block', open);
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', String(open));
    var caret = toggle.querySelector('[data-bt-facets-caret]');
    if (caret) caret.classList.toggle('rotate-180', open);
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      setOpen(!isOpen());
    });
  }

  // Hydrogen keeps the panel open while filters change (client-side navigation).
  // Here the page reloads, so the open state is carried across that one reload.
  try {
    if (sessionStorage.getItem(OPEN_KEY)) {
      sessionStorage.removeItem(OPEN_KEY);
      setOpen(true);
    }
  } catch (e) { /* private mode */ }

  if (!form) return;

  // ── Submit ───────────────────────────────────────────────────────────────
  // Like Hydrogen's apply(): no empty price bounds and no sort param for "Default" in the URL.
  // A GET submit rebuilds the query string from the form, so `page` is dropped as well.
  function prepare() {
    each(form.elements, function (el) {
      var skip = false;
      if (el.type === 'number' && el.value.trim() === '') skip = true;
      if (el.hasAttribute('data-bt-facets-sort')) {
        var option = el.options[el.selectedIndex];
        if (option && option.hasAttribute('data-bt-sort-default')) skip = true;
      }
      if (skip && !el.disabled) {
        el.disabled = true;
        el.setAttribute('data-bt-facets-skipped', '');
      }
    });
    try {
      if (isOpen()) sessionStorage.setItem(OPEN_KEY, '1');
    } catch (e) { /* private mode */ }
  }

  form.addEventListener('submit', prepare);

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || el.form !== form) return;
    if (el.type === 'checkbox' || el.hasAttribute('data-bt-facets-sort')) {
      prepare();
      form.submit();
    }
  });

  // Back/forward cache: give the controls back when the page is restored.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    each(form.elements, function (el) {
      if (!el.hasAttribute('data-bt-facets-skipped')) return;
      el.disabled = false;
      el.removeAttribute('data-bt-facets-skipped');
    });
  });
})();
